import {
  Box,
  Stack,
  Text,
  Column,
  Columns,
  IconUpload,
  IconVisibility,
  IconSearch,
  Hidden,
} from 'braid-design-system';
import React from 'react';

import iconReposition from '../images/icon-reposition.svg';

import * as styles from '../style/style.css';

const data = [
  {
    icon: <IconUpload tone="secondary" />,
    text: 'Upload/edit logo',
  },
  {
    icon: <IconUpload tone="secondary" />,
    text: 'Upload/edit cover image',
  },
  {
    icon: (
      <Box
        display="block"
        style={{
          backgroundImage: `url('data:image/svg+xml;utf8,${iconReposition.replace(
            /\#/g,
            '%23',
          )}')`,
          width: '20px',
          height: '20px',
          backgroundSize: 'cover',
        }}
      />
    ),
    text: 'Reposition cover image',
  },
  {
    icon: <IconVisibility tone="secondary" />,
    text: 'Preview brand',
  },
  {
    icon: <IconSearch tone="secondary" />,
    text: 'Search brands',
  },
];

interface LogoBoxInterface {
  icon: any;
  text: string;
}

const LogoBox = (item: LogoBoxInterface) => (
  <Box
    background="surface"
    paddingTop="xsmall"
    paddingX="small"
    className={styles.logobox}
  >
    <Stack space="xsmall" align="center">
      {item.icon}
      <Box style={{ maxWidth: '84px' }}>
        <Text align="center" tone="secondary" size="small">
          {item.text}
        </Text>
      </Box>
    </Stack>
  </Box>
);

const BrandingTools = () => (
  <Box>
    <Hidden below="tablet">
      <Columns space="gutter" collapseBelow="tablet" align="center">
        {data.map((item, i) => (
          <Column key={i}>
            <LogoBox icon={item.icon} text={item.text} />
          </Column>
        ))}
      </Columns>
    </Hidden>
    <Hidden above="mobile">
      <Columns space="small" collapseBelow="tablet" align="center">
        <Column>
          <Columns space="small">
            {data.splice(0, 3).map((item, i) => (
              <Column key={i}>
                <LogoBox icon={item.icon} text={item.text} />
              </Column>
            ))}
          </Columns>
        </Column>
        <Column>
          <Columns space="small">
            {data.map((item, i) => (
              <Column key={i}>
                <LogoBox icon={item.icon} text={item.text} />
              </Column>
            ))}
          </Columns>
        </Column>
      </Columns>
    </Hidden>
  </Box>
);

export default BrandingTools;
